module.exports = __webpack_public_path__ + "media/images/emblems/Rain_LU-92be4b9fcce91ea5cd8414affecb5d6e.png";